<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <div class="row align-items-end pt-2">
              <filter-component
                @filter="handleFilter"
                @onChangeFilters="handleFilterChange"
                @showHideLoading="showHideLoading"
                :filterOfLots="canShow"
                :isMultipleFarms="false"
                :isRequiredFarms="true"
                :isRequiredLots="false"
                :classFarms="`col-12 col-md-6 col-lg-4 col-xl-4`"
                :classLots="`col-12 col-md-6 col-lg-5 col-xl-4`"
              >
                <template slot="prev">
                  <div class="col-12 col-md-6 col-lg-4 col-xl-4 pt-3">
                    <label>{{ $t('common_words.report_type') }}: * </label>
                    <br />
                    <el-select
                      clearable
                      filterable
                      @change="showLotByReportType()"
                      v-model="model.report_id"
                      :placeholder="`${$t('common_words.select')}...`"
                      class="select-primary custom-width-select shadow-sm required-report"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in report_type"
                        :key="item.id + item.name"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </template>
              </filter-component>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
      <div v-if="isIndex()">
        <div
          v-if="haveData"
          class="row mx-1 d-flex flex-wrap justify-content-between align-items-center"
        >
          <div class="p-0 pr-1 m-0 col-12 col-md-12 col-lg-6">
            <card>
              <div class="row">
                <div class="col-12">
                  <highcharts :options="reportLineExprecting"></highcharts>
                </div>
              </div>
            </card>
          </div>
          <div class="p-0 pl-1 m-0 col-12 col-md-12 col-lg-6">
            <card>
              <div class="row">
                <div class="col-12">
                  <highcharts :options="reportLine"></highcharts>
                </div>
              </div>
            </card>
          </div>
          <div
            v-if="showYoungPlants"
            class="p-0 pl-1 m-0 col-12 col-md-12 col-lg-12"
          >
            <card>
              <div class="row">
                <div class="col-12">
                  <highcharts :options="reportLineYoung"></highcharts>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
      <div v-if="isIndex()">
        <div v-if="haveData">
          <card
            class="custom-shadow-card-header"
            :title="$t('sigatoka.sigatoka_capture_report')"
          >
            <div class="row w-100 pl-3 pr-3">
              <div class="col-12 p-0">
                <el-collapse
                  v-model="activeAgeTables"
                  class="age-report-collapse"
                >
                  <el-collapse-item
                    v-for="ageTable in ageTables"
                    :key="'age-table-' + ageTable.age"
                    :name="String(ageTable.age)"
                  >
                    <template slot="title">
                      <div class="w-100 d-flex align-items-center">
                        <strong class="ml-3">
                          {{ ageTable.label }}
                        </strong>
                      </div>
                    </template>
                    <div class="table-responsive age-table-wrapper">
                      <table
                        class="table table-striped table-bordered mb-0 w-100"
                      >
                        <thead class="cusmtom-thead-color">
                          <tr class="cusmtom-thead-color">
                            <th
                              rowspan="2"
                              class="text-center p-3 custom-header-label"
                            >
                              {{ $t('common_words.date') }}
                            </th>
                            <th
                              v-if="isDetailed"
                              rowspan="2"
                              class="text-center p-3 custom-header-label"
                            >
                              {{ $t('common_words.allotment') }}
                            </th>
                            <th
                              rowspan="2"
                              class="text-center p-3 custom-header-label"
                            >
                              {{ $t('sigatoka.total_functional_leaves') }}
                            </th>
                            <th
                              rowspan="2"
                              class="text-center p-3 custom-header-label"
                            >
                              {{ $t('sigatoka.yls') }}
                            </th>
                            <th
                              v-if="ageTable.includeYli"
                              rowspan="2"
                              class="text-center p-3 custom-header-label"
                            >
                              {{ $t('sigatoka.yli') }}
                            </th>
                            <th
                              v-if="ageTable.hasInfectionPicture"
                              colspan="5"
                              class="text-center p-3 custom-header-label"
                            >
                              {{ $t('sigatoka.infection_picture') }}
                            </th>
                          </tr>
                          <tr
                            v-if="ageTable.hasInfectionPicture"
                            class="cusmtom-thead-color"
                          >
                            <th
                              v-for="grade in [0, 1, 2, 3, 4]"
                              :key="
                                'grade-header-' + ageTable.age + '-' + grade
                              "
                              class="text-center p-3 custom-header-label infection-column"
                            >
                              {{ grade }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in ageTable.rows" :key="row.key">
                            <td class="text-center">
                              {{ row.date }}
                            </td>
                            <td v-if="isDetailed" class="text-center">
                              {{ row.lot }}
                            </td>
                            <td class="text-center">
                              {{ row.total_leaves }}
                            </td>
                            <td class="text-center">
                              {{ row.yls }}
                            </td>
                            <td v-if="ageTable.includeYli" class="text-center">
                              {{ row.yli }}
                            </td>
                            <template v-if="ageTable.hasInfectionPicture">
                              <td
                                v-for="grade in [0, 1, 2, 3, 4]"
                                :key="
                                  'grade-value-' +
                                  ageTable.age +
                                  '-' +
                                  row.key +
                                  '-' +
                                  grade
                                "
                                class="text-center infection-column"
                              >
                                {{
                                  row.infection_picture &&
                                  row.infection_picture[grade] !== undefined &&
                                  row.infection_picture[grade] !== null
                                    ? row.infection_picture[grade]
                                    : '-'
                                }}
                              </td>
                            </template>
                          </tr>
                          <tr v-if="ageTable.rows.length === 0">
                            <td
                              :colspan="
                                4 +
                                (ageTable.includeYli ? 1 : 0) +
                                (ageTable.hasInfectionPicture ? 5 : 0)
                              "
                              class="text-center p-4"
                            >
                              {{ $t('common_words.unavailable_data') }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item
                    v-if="showYoungPlants"
                    :key="'young_plants'"
                    :name="'young_plants'"
                  >
                    <template slot="title">
                      <div class="w-100 d-flex align-items-center">
                        <strong class="ml-3">
                          {{ $t('sigatoka.young_plants') }}
                        </strong>
                      </div>
                    </template>
                    <div class="table-responsive age-table-wrapper">
                      <table
                        class="table table-striped table-bordered mb-0 w-100"
                      >
                        <thead class="cusmtom-thead-color">
                          <tr class="cusmtom-thead-color">
                            <th class="text-center p-3 custom-header-label">
                              {{ $t('common_words.date') }}
                            </th>
                            <th
                              v-if="isDetailed"
                              class="text-center p-3 custom-header-label"
                            >
                              {{ $t('common_words.allotment') }}
                            </th>
                            <th class="text-center p-3 custom-header-label">
                              {{ $t('sigatoka.total_functional_leaves') }}
                            </th>
                            <th class="text-center p-3 custom-header-label">
                              {{ $t('sigatoka.ref') }}
                            </th>
                            <th
                              v-for="leaf in youngData()"
                              :key="leaf"
                              style="min-width: 85px"
                              class="text-center p-3 custom-header-label"
                            >
                              {{ $t('sigatoka.leaf') }} {{ leaf }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in youngPlantRows" :key="row.key">
                            <td class="text-center">
                              {{ row.date }}
                            </td>
                            <td v-if="isDetailed" class="text-center">
                              {{ row.lot }}
                            </td>
                            <td class="text-center">
                              {{ row.functional_leaf }}
                            </td>
                            <td class="text-center">
                              {{ row.ref }}
                            </td>
                            <td
                              v-for="leaf in youngData()"
                              :key="'young-leaf-' + row.key + '-' + leaf"
                              class="text-center"
                            >
                              {{
                                row.leaves &&
                                row.leaves[leaf] !== undefined &&
                                row.leaves[leaf] !== null
                                  ? row.leaves[leaf]
                                  : '-'
                              }}
                            </td>
                          </tr>
                          <tr v-if="youngPlantRows.length === 0">
                            <td
                              :colspan="
                                3 + (isDetailed ? 1 : 0) + youngData().length
                              "
                              class="text-center p-4"
                            >
                              {{ $t('common_words.unavailable_data') }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
            <export-tables class="mb-3 mt-3" :pdf="pdf" :xls="xls" />
          </card>
        </div>
      </div>
      <not-index-permissions v-else />
    </div>
  </div>
</template>
<script>
import i18n from 'src/i18n';
import { Chart } from 'highcharts-vue';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import MixinCharts from 'src/util/mixinCharts';
import MixinMasters from 'src/util/mixinMasters';
import { isset, getDateToday } from 'src/util/Util';
import Filter from 'src/components/Filter/Filters.vue';
import MixinPermissions from 'src/util/mixinPermissions';
import ExportTables from 'src/components/Tables/ExportTables.vue';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';

export default {
  mixins: [
    MixinMenu,
    MixinCharts,
    MixinMasters,
    MixinPermissions,
    MixinValidations,
  ],
  components: {
    [ExportTables.name]: ExportTables,
    [Filter.name]: Filter,
    highcharts: Chart,
  },
  data() {
    return {
      lots: [],
      farms: [],
      reportLine: [],
      canShow: false,
      haveData: false,
      reportTable: [],
      isDetailed: false,
      valueCollapse: null,
      reportLineYoung: [],
      activeName: 'filter',
      activeAgeTables: [],
      reportLineExprecting: [],
      model: {
        year: null,
        lot_id: [],
        farm_id: null,
        report_id: null,
      },
    };
  },
  computed: {
    pdf() {
      return {
        filename: `${i18n.t('sigatoka.sigatoka_capture_report')}_${
          this.dateToday
        }.pdf`,
        route: 'sigatoka/capture/pdf',
        paramMethod: 'POST',
        plusData: {
          data: this.reportTable,
        },
      };
    },
    xls() {
      return {
        filename: `${i18n.t('sigatoka.sigatoka_capture_report')}_${
          this.dateToday
        }.xlsx`,
        route: 'sigatoka/capture/excel',
        paramMethod: 'POST',
        plusData: {
          data: this.reportTable,
        },
      };
    },
    dateToday() {
      return getDateToday();
    },
    report_type() {
      return [
        {
          id: 2,
          name: i18n.t('common_words.detailed'),
        },
        {
          id: 1,
          name: i18n.t('common_words.consolidated'),
        },
      ];
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    ages() {
      if (!this.reportTable.length) return [];
      return this.reportTable[0].ages || [];
    },
    ageTables() {
      if (!this.reportTable.length) return [];

      return this.ageColumns.map((column) => {
        const rows = [];
        this.reportTable.forEach((item) => {
          const found = item.totals.find(
            (total) => Number(total.age) === Number(column.age)
          );
          if (!found) return;
          const metrics = found.metrics || {};
          rows.push({
            key:
              item.id +
              '-' +
              column.age +
              '-' +
              (item.lot ? item.lot.id : 'consolidated'),
            date: item.date,
            lot: item.lot ? item.lot.name : '-',
            total_leaves:
              metrics.total_leaves !== undefined ? metrics.total_leaves : 0,
            yls: metrics.yls !== undefined ? metrics.yls : 0,
            yli: metrics.yli !== undefined ? metrics.yli : '-',
            infection_picture: found.infection_picture || null,
          });
        });
        const includeYli = column.metrics && column.metrics.includes('yli');
        const hasInfectionPicture =
          column.infection_picture === true ||
          this.reportTable.some((item) => {
            if (!item.totals) return false;
            const found = item.totals.find(
              (total) => Number(total.age) === Number(column.age)
            );

            return !!(found && found.infection_picture);
          });

        return {
          age: column.age,
          label: column.label,
          includeYli,
          hasInfectionPicture,
          rows,
        };
      });
    },
    youngPlantRows() {
      if (!this.reportTable.length) return [];

      return this.reportTable
        .filter((item) => item.youngPlants)
        .map((item) => {
          return {
            key:
              item.id + '-young-' + (item.lot ? item.lot.id : 'consolidated'),
            date: item.date,
            lot: item.lot ? item.lot.name : '-',
            functional_leaf:
              item.youngPlants.functional_leaf !== undefined
                ? item.youngPlants.functional_leaf
                : 0,
            ref: item.youngPlants.ref !== undefined ? item.youngPlants.ref : 0,
            leaves: item.youngPlants.leaves || {},
          };
        });
    },
    farm() {
      if (!this.reportTable.length) return;
      const farm = {};
      this.reportTable.forEach((item) => {
        farm[item.farm.id] = item.farm;
      });

      return Object.values(farm);
    },
    hasLot() {
      if (!this.reportTable.length) return;

      return this.reportTable.some((item) => item.lot);
    },
    showYoungPlants() {
      return (
        this.reportTable.length &&
        this.reportTable[0].youngPlants &&
        this.reportTable[0].youngPlants.functional_leaf > 0 &&
        this.reportTable[0].youngPlants.ref > 0
      );
    },
    youngColspan() {
      return Object.keys(this.reportTable[0].youngPlants.leaves).length + 2;
    },
    ageColumns() {
      if (!this.reportTable.length) return [];
      return this.reportTable[0].ageColumns || [];
    },
  },
  methods: {
    handleFilter(data) {
      this.dataFilter = { ...data };
      this.getData();
    },
    handleFilterChange() {
      this.haveData = false;
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    hasInfectionPicture(age) {
      if (!this.reportTable.length) return false;
      return this.reportTable.some((item) => {
        if (!item.totals) return false;
        const ageData = item.totals.find(
          (total) => Number(total.age) === Number(age)
        );

        return (
          ageData &&
          ageData.infection_picture &&
          Object.keys(ageData.infection_picture).length > 0
        );
      });
    },
    showLotByReportType() {
      this.haveData = false;
      this.model.report_id == 2 ? (this.canShow = true) : this.cleanLot();
    },
    cleanLot() {
      this.model.lot_id = [];
      this.canShow = false;
    },
    youngData() {
      if (this.showYoungPlants) {
        const leaf = this.reportTable[0].youngPlants.leaves;
        return Object.keys(leaf).map(Number);
      }
    },
    validate() {
      if (!isset(this.model.report_id))
        return this.validationInputsRequired('report');
    },
    getGradeValue(found, grade) {
      if (!found || !found.grades) return 0;

      return found.grades[grade] !== undefined ? found.grades[grade] : 0;
    },
    async getReport() {
      this.showHideLoading(true);
      const data = this.dataFilter;
      data.report_id = this.model.report_id;
      data.route = 'sigatoka/capture/filterdata';
      const responseReport = await Promise.all([Axios.postMasters(data)]).catch(
        (error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        }
      );

      if (!responseReport[0] || !responseReport[0].data.data) {
        this.showHideLoading();
        SweetAlert.warning(i18n.t('common_words.unavailable_data'));
        return [];
      }
      return responseReport[0].data.data;
    },
    getAgeColspan(column) {
      const metricsCount = column.metrics ? column.metrics.length : 0;
      const infectionCount = column.infection_picture === true ? 5 : 0;

      return metricsCount + infectionCount;
    },
    setData(response) {
      this.model.report_id == 2
        ? (this.isDetailed = true)
        : (this.isDetailed = false);
      this.reportTable = response.formatTable;
      this.reportLine = this.lines(response.formatLineChart);
      this.reportLineExprecting = this.lines(response.formatLineChartExpecting);
      this.reportLineYoung = this.lines(response.formatLineChartYoungPlants);
      this.haveData = true;

      this.showHideLoading();
    },
    async getData() {
      if (this.isIndex()) {
        if (this.validate()) return;
        const response = await this.getReport();
        if (response.length === 0) return;
        this.setData(response);
      } else this.showHideLoading();
    },
  },
  mounted() {
    this.selectedItemOnMenu('sigatoka');
  },
};
</script>
<style scoped>
.custom-scroll-table-wrapper {
  max-height: 600px;
  overflow: auto;
}
</style>
